const visions: {
  name: string;
  imagePath: string;
  pdHeightStatus?: boolean;
  tooltip?: string;
}[] = [
  {
    imagePath: 'https://visionhub.transitions.com/content/Lens/vision/progressive.jpg',
    name: 'Near',
    tooltip:
      'Nearsighted (Myopia) is a condition of the eye where the light that comes in does not directly focus on the retina but in front of it.',
  },
  {
    imagePath: 'https://visionhub.transitions.com/content/Lens/vision/progressive.jpg',
    name: 'Far',
    tooltip:
      'Farsighted (hyperopia) is a condition of the eye where visual image being focused behind the retina rather than directly on it which means a hyperopic sees things better far away than close up.',
  },
  {
    imagePath: 'https://visionhub.transitions.com/content/Lens/vision/progressive.jpg',
    name: 'Near to Far',
    tooltip:
      'Presbyopia is not a visual defect but a natural change in vision which affects everyone.',
    pdHeightStatus: true,
  },
];
export default visions;
